import { Component, Emit, Inject, Model, Provide, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class Login extends Vue {
  private $api: any;
  private $cookie: any;
  private isMobile: boolean = true;
  private isOrigin: boolean = false;
  private isVertical: boolean = true;
  private translateX: number = 0;
  private pageData: any = {
    title: '中瑞集团8周年庆典',
    name: '戴用名',
    date: '2019年10月18日 10:18分',
    address: '山东省青岛市市北区鸿府国际大厦',
    depart: '企划工程事业部',
    // depart: '中瑞研发中心智投产品规划二部快富通&犀鸟组服务商渠道组',
    price: '2019',
    num: 20111018,
    ticketNum: 20191018,
    code: 'ZR16070020',
    home: 'zhongruigroup.com',
    seat: '1排1座',
  };
  private screenWidth: number = 0;
  private screenHeight: number = 0;
  private proportion: number = 0;
  private isLoading: boolean = false;

  constructor() {
    super();
  }

  // lifes
  public async getData() {
    this.$toast.loading({
      mask: true,
      message: '加载中...',
      duration: 0,
    });
    const DATA = await this.$api.httpGet('BaiDuApi/BaiDuFace/GetUserInfoByCode', {
      codeStr: this.$cookie.get('CURLOGINNAME'),
      isEncrypt: false,
    });
    if (DATA.Success) {
      this.pageData.code = DATA.Data.Code;
      this.pageData.name = DATA.Data.UserName;
      this.pageData.depart = DATA.Data.DepartName;
      if (window.localStorage.getItem('INVITAION_ADDRESS')) {
        this.pageData.address = window.localStorage.getItem('INVITAION_ADDRESS');
      }
      this.$toast.clear();
      this.isLoading = true;
    } else {
      this.$toast.clear();
      this.isLoading = true;
      this.$dialog.alert({
        message: DATA.AllMessages,
      });
    }
  }

  public mounted() {
    this.$toast.loading({
      mask: true,
      duration: 0,
      message: '加载中...',
    });
    if (this.IsPC()) {
      if (document.body.offsetWidth < 1200) {
        this.isOrigin = false;
        this.proportion = document.body.offsetWidth / 1200;
      } else {
        this.isOrigin = true;
      }
      this.isMobile = false;
      this.$toast.clear();
    } else {
      if (document.body.offsetWidth < 1200) {
        this.isOrigin = false;
        this.listenScreen();
      } else {
        this.isOrigin = true;
      }
      this.isMobile = true;
      this.$toast.clear();
      window.addEventListener('onorientationchange' in window ? 'orientationchange' : 'resize', this.listenScreen, false);
    }
    this.getData();
  }

  private destroy() {
    window.localStorage.removeItem('INVITAION_ADDRESS');
    this.$cookie.del('PATH_ROUTE');
  }

  // methods
  private listenScreen() {
    if (window.orientation === 0 || window.orientation === 180) {
      const direction = window.localStorage.getItem('screen-direction');
      if (direction === 'Horizontal') {
        window.location.reload();
      }
      // console.log('竖屏');
      window.localStorage.setItem('screen-direction', 'Vertical');
      this.isVertical = true;
      if (document.body.offsetWidth < 1200) {
        this.isOrigin = true;
        this.proportion = document.body.offsetWidth / 464.89;
        this.translateX = document.body.offsetHeight * (1 - this.proportion);
      } else {
        this.isOrigin = false;
      }
      // orientation = 'portrait';
      return false;
    } else if (window.orientation === 90 || window.orientation === -90) {
      const direction = window.localStorage.getItem('screen-direction');
      if (direction === 'Vertical') {
        window.location.reload();
      }
      // console.log('横屏');
      window.localStorage.setItem('screen-direction', 'Horizontal');
      this.isVertical = false;
      if (document.body.offsetWidth < 1200) {
        this.isOrigin = true;
      } else {
        this.isOrigin = false;
      }
      this.proportion = document.body.offsetWidth / 1200;
      // orientation = 'landscape';
      return false;
    }
  }

  private IsPC() {
    const userAgentInfo = navigator.userAgent;
    const Agents = new Array('Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod');
    let flag = true;
    // tslint:disable-next-line:prefer-for-of
    for (let v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false;
        break;
      }
    }
    return flag;
  }

  // 解码
  private decodeUnicode(str: string) {
    str = str.replace(/\\/g, '%');
    return unescape(str);
  }
}
